module.exports = __webpack_public_path__ + "static/img/shiziwan4.f23d5d7e.png";